/**
 * OmniaStores — "Complete the look" matching upsells for UpCart (v5)
 *
 * Primary mode: feeds matched products into UPCART'S OWN upsell module, so they
 * use UpCart's styling, carousel/list setting and responsive behaviour.
 * Fallback mode: renders its own block (shadow-DOM aware) only if UpCart's
 * module never shows them.
 *
 * Matching always reads the DEFAULT-LOCALE product data (English titles), so it
 * works identically on /ar. Display data comes from the shopper's locale.
 *
 * QA:  __omniaMatch.check()   __omniaMatch.preview('handle')   __omniaMatch.audit('full set')
 */
(function () {
  'use strict';

  var CONFIG = {
    rules: {
      'full set': ['ring'],
      'necklace': ['ring', 'earrings', 'bracelet', 'brooch'],
      'ring':     ['earrings', 'necklace', 'bracelet'],
      'earrings': ['ring', 'necklace', 'bracelet'],
      'bracelet': ['ring', 'earrings', 'necklace'],
      'brooch':   ['ring', 'earrings', 'bracelet']
    },
    sourcePriority: ['full set', 'necklace', 'bracelet', 'earrings', 'ring', 'brooch'],

    // 'auto'   = UpCart's own module, fall back to own block if it doesn't show them
    // 'native' = UpCart's module only
    // 'block'  = own block only
    renderMode: 'native',
    appendNative: true,          // after our matches, keep UpCart's own picks to fill slots
    layout: 'carousel',          // fallback block only: 'carousel' | 'list'

    maxItems: 6,
    perTypeLimit: 2,
    neutralFallback: 'white',
    alwaysFill: true,            // never show an empty upsell slot
    minItems: 3,                 // fillers only top up to this many, so good matches aren't diluted
    matchLocaleRoot: '/',        // default locale — where English titles live
    catalogCollection: 'all',
    maxPages: 10,
    cacheTtlMs: 30 * 60 * 1000,

    mountId: 'omnia-match',
    autoMount: true,
    copy: {
      heading: 'Complete the look', headingAr: 'أكملي الإطلالة',
      sub: 'Matched to your {color} {name}', subAr: 'قطع تناسب {name}',
      add: 'Add', addAr: 'أضيفي', adding: '…', added: 'Added', addedAr: 'تمت الإضافة',
      chooseSize: 'Choose size', chooseSizeAr: 'اختاري المقاس', soldOut: 'Sold out'
    },
    debug: true
  };

  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var BASE = CONFIG.matchLocaleRoot;
  var CATALOG_KEY = 'omnia-match-catalog-v5:' + BASE + CONFIG.catalogCollection;
  var RTL = /^ar/i.test((document.documentElement.getAttribute('lang') || '')) ||
    document.documentElement.getAttribute('dir') === 'rtl';

  // ---------- vocabulary (matched against default-locale titles) ----------
  var TYPE_KW = [
    ['full set', /\b(full (jewe?l+e?ry )?set|bridal (full )?set|full set)\b/i],
    ['brooch',   /\bbrooch(es)?\b/i],
    ['bracelet', /\b(bracelets?|bangles?|cuffs?)\b/i],
    ['earrings', /\b(earrings?|studs?)\b/i],
    ['ring',     /\brings?\b/i],
    ['necklace', /\b(necklaces?|pendants?|chokers?|collar)\b/i]
  ];
  var TYPE_ALIASES = {
    'full set': 'full set', 'full sets': 'full set', 'sets': 'full set', 'set': 'full set',
    'bridal set': 'full set', 'necklace': 'necklace', 'necklaces': 'necklace', 'pendant': 'necklace',
    'ring': 'ring', 'rings': 'ring', 'earring': 'earrings', 'earrings': 'earrings',
    'bracelet': 'bracelet', 'bracelets': 'bracelet', 'bangle': 'bracelet', 'bangles': 'bracelet',
    'brooch': 'brooch', 'brooches': 'brooch'
  };
  var TYPE_LABEL = { 'full set': 'set', necklace: 'necklace', ring: 'ring', earrings: 'earrings', bracelet: 'bracelet', brooch: 'brooch' };
  var COLOR_WORDS = {
    'rose gold': 'rose gold', 'white gold': 'white', 'yellow gold': 'gold',
    'multicolour': 'multi', 'multicolor': 'multi', 'multi color': 'multi', 'multi-color': 'multi',
    golden: 'gold', gold: 'gold', silver: 'white', white: 'white', pearl: 'white', clear: 'white', crystal: 'white',
    red: 'red', ruby: 'red', burgundy: 'red', maroon: 'red',
    blue: 'blue', sapphire: 'blue', navy: 'blue', turquoise: 'blue', aqua: 'blue',
    green: 'green', emerald: 'green', olive: 'green',
    pink: 'pink', coral: 'pink', blush: 'pink', rose: 'pink',
    purple: 'purple', lilac: 'purple', lavender: 'purple', violet: 'purple',
    yellow: 'yellow', black: 'black', champagne: 'champagne'
  };
  var MULTI_MATCHES = ['multi', 'white'];
  var COLOR_NAME = { white: 'white', gold: 'gold', 'rose gold': 'rose gold', red: 'red', blue: 'blue', green: 'green',
    pink: 'pink', purple: 'purple', yellow: 'yellow', black: 'black', multi: 'multicolor', champagne: 'champagne' };
  var COLOR_AR = { white: 'الأبيض', gold: 'الذهبي', red: 'الأحمر', blue: 'الأزرق', green: 'الأخضر',
    pink: 'الوردي', purple: 'البنفسجي', yellow: 'الأصفر', black: 'الأسود', multi: 'متعدد الألوان' };
  var SWATCH = { white: '#eceef1', gold: '#c9a449', 'rose gold': '#d4a095', red: '#a3202a', blue: '#2a56a8',
    green: '#2b7a4b', pink: '#e39ab2', purple: '#6f4a9c', yellow: '#e2bd35', black: '#1c1c1c', champagne: '#e3cfa5' };
  var MATERIALS = [
    ['925 silver', /(925|92\.5)\s*(sterling\s*)?silver|sterling silver/i],
    ['rhodium plated', /rhodium/i],
    ['gold plated', /gold[- ]?plated/i]
  ];
  var MATERIAL_LABEL = { '925 silver': '925 silver', 'rhodium plated': 'Rhodium plated', 'gold plated': 'Gold plated' };
  var COLOR_RE = new RegExp('(?:^|[^a-z])(' + Object.keys(COLOR_WORDS)
    .sort(function (a, b) { return b.length - a.length; })
    .map(function (w) { return w.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); }).join('|') + ')(?=[^a-z]|$)', 'g');

  function log() { if (CONFIG.debug) console.log.apply(console, ['[omnia-match]'].concat([].slice.call(arguments))); }
  function norm(s) { return String(s == null ? '' : s).trim().toLowerCase().replace(/\s+/g, ' '); }
  function uniq(a) { return a.filter(function (x, i) { return x && a.indexOf(x) === i; }); }
  function cap(s) { s = String(s || ''); return s.charAt(0).toUpperCase() + s.slice(1); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function t(key) { return RTL && CONFIG.copy[key + 'Ar'] ? CONFIG.copy[key + 'Ar'] : CONFIG.copy[key]; }

  // ---------- title parsing ----------
  function nameSegment(title) {
    var s = String(title || '');
    var cut = s.search(/\s(?:in|with|–|—|\|)\s|\s-\s|,|\(/i);
    return (cut > 0 ? s.slice(0, cut) : s).trim();
  }
  function colorWords(text) {
    var s = norm(text).replace(/\b(emerald|pear|oval|round|princess|radiant|asscher|marquise|heart|cushion)[- ]cut\b/g, ' ');
    var out = [], m;
    COLOR_RE.lastIndex = 0;
    while ((m = COLOR_RE.exec(s))) out.push(COLOR_WORDS[m[1]]);
    return uniq(out);
  }
  function typeOf(text) {
    for (var i = 0; i < TYPE_KW.length; i++) if (TYPE_KW[i][1].test(text || '')) return TYPE_KW[i][0];
    return null;
  }
  function materialOf(title) {
    for (var i = 0; i < MATERIALS.length; i++) if (MATERIALS[i][1].test(title || '')) return MATERIALS[i][0];
    return null;
  }
  function shortName(title) { return nameSegment(title).replace(/^omnia\s+/i, '').split(/\s+/)[0] || ''; }
  function displayName(title) { return nameSegment(title).replace(/^omnia\s+/i, ''); }

  function colorOptionIndex(p) {
    var opts = p.options || [];
    for (var i = 0; i < opts.length; i++) {
      var n = typeof opts[i] === 'string' ? opts[i] : opts[i] && opts[i].name;
      if (/colou?r|metal|plating|اللون|لون/i.test(n || '')) return i;
    }
    return -1;
  }
  function optionColors(p, variant) {
    var idx = colorOptionIndex(p);
    if (idx < 0 || !variant) return [];
    var v = variant['option' + (idx + 1)];
    var c = colorWords(v);
    return c.length ? c : (v ? [norm(v)] : []);
  }
  function priceCents(p) {
    if (typeof p.price === 'number') return p.price;
    var v = (p.variants || [])[0];
    return v ? Math.round(parseFloat(v.price) * 100) : 0;
  }
  function sourceProfile(p, variantId) {
    var variant = (p.variants || []).find(function (v) { return String(v.id) === String(variantId); }) || (p.variants || [])[0];
    var colors = colorWords(nameSegment(p.title));
    if (!colors.length) colors = optionColors(p, variant);
    var pt = norm(p.product_type || p.type);
    return {
      id: p.id, handle: p.handle, title: p.title,
      type: typeOf(nameSegment(p.title)) || typeOf(p.title) || TYPE_ALIASES[pt] || typeOf(pt) || 'unknown',
      colors: colors, primary: colors[0] || null, material: materialOf(p.title),
      price: variant && typeof variant.price === 'number' ? variant.price : priceCents(p),
      name: shortName(p.title)
    };
  }
  function candidateProfile(p) {
    var variants = (p.variants || []).filter(function (v) { return v.available; });
    if (!variants.length) return null;
    var colors = colorWords(nameSegment(p.title));
    variants.forEach(function (v) { colors = colors.concat(optionColors(p, v)); });
    colors = uniq(colors);
    var pt = norm(p.product_type || p.type);
    return {
      id: p.id, handle: p.handle,
      type: typeOf(nameSegment(p.title)) || typeOf(p.title) || TYPE_ALIASES[pt] || typeOf(pt) || 'unknown',
      colors: colors, material: materialOf(p.title), price: priceCents(p)
    };
  }

  // ---------- data (match = default locale, display = shopper locale) ----------
  var productCache = new Map();
  var catalogPromise = null;

  function getProduct(handle, root) {
    root = root || ROOT;
    var key = root + '|' + handle;
    if (!productCache.has(key)) {
      productCache.set(key, fetch(root + 'products/' + handle + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; }));
    }
    return productCache.get(key);
  }
  function getMatchProduct(handle) { return getProduct(handle, BASE); }

  function loadCatalog() {
    if (catalogPromise) return catalogPromise;
    try {
      var cached = JSON.parse(sessionStorage.getItem(CATALOG_KEY) || 'null');
      if (cached && cached.data && cached.data.length && Date.now() - cached.ts < CONFIG.cacheTtlMs) {
        return (catalogPromise = Promise.resolve(cached.data));
      }
    } catch (e) {}
    catalogPromise = (async function () {
      var index = [];
      for (var page = 1; page <= CONFIG.maxPages; page++) {
        var r = await fetch(BASE + 'collections/' + CONFIG.catalogCollection + '/products.json?limit=250&page=' + page);
        if (!r.ok) { log('catalog fetch failed', r.status); break; }
        var products = (await r.json()).products || [];
        if (!products.length) break;
        products.forEach(function (p) { var c = candidateProfile(p); if (c) index.push(c); });
        if (products.length < 250) break;
      }
      if (index.length) {
        try { sessionStorage.setItem(CATALOG_KEY, JSON.stringify({ ts: Date.now(), data: index })); } catch (e) {}
      } else { catalogPromise = null; }
      var counts = {};
      index.forEach(function (c) { counts[c.type] = (counts[c.type] || 0) + 1; });
      log('catalog indexed', index.length, counts, '| locale:', ROOT, '| matching from:', BASE);
      return index;
    })().catch(function (e) { log('catalog error', e); catalogPromise = null; return []; });
    return catalogPromise;
  }

  // ---------- ranking ----------
  function expand(colors) {
    var out = [];
    colors.forEach(function (c) { if (c === 'multi') out = out.concat(MULTI_MATCHES); else out.push(c); });
    return uniq(out);
  }
  function priceScore(src, c) {
    if (!src.price || !c.price) return 0;
    return Math.max(0, 10 - Math.abs(Math.log(c.price / (src.price * 0.6))) * 5);
  }
  function rank(src, catalog, excludeIds) {
    var targets = CONFIG.rules[src.type] || CONFIG.rules['necklace'];
    var srcColors = expand(src.colors || []);
    var primary = expand([src.primary]);
    var per = targets.length === 1 ? CONFIG.maxItems : CONFIG.perTypeLimit;

    var buckets = targets.map(function (target) {
      var scored = [];
      catalog.forEach(function (c) {
        if (c.type !== target || c.id === src.id || excludeIds.has(String(c.id))) return;
        var score = 0, via = null;
        var p = primary.find(function (x) { return c.colors.indexOf(x) !== -1; });
        var s = srcColors.find(function (x) { return c.colors.indexOf(x) !== -1; });
        if (p) { score = 100; via = p; }
        else if (s) { score = 70; via = s; }
        else if (CONFIG.neutralFallback && c.colors.indexOf(CONFIG.neutralFallback) !== -1) { score = 30; via = CONFIG.neutralFallback; }
        if (!score) return;
        if (src.material && c.material === src.material) score += 20;
        score += priceScore(src, c);
        scored.push({ c: c, score: score, color: via });
      });
      scored.sort(function (a, b) { return b.score - a.score; });
      if (scored.some(function (x) { return x.score >= 70; })) scored = scored.filter(function (x) { return x.score >= 70; });
      return scored.slice(0, per);
    });

    var out = [], seen = new Set();
    for (var round = 0; out.length < CONFIG.maxItems; round++) {
      var any = false;
      buckets.forEach(function (b) {
        var x = b[round];
        if (!x) return;
        any = true;
        if (out.length < CONFIG.maxItems && !seen.has(x.c.id)) { seen.add(x.c.id); out.push(x); }
      });
      if (!any) break;
    }

    // never leave the slot empty: fill with the best-priced pieces of the target types
    if (CONFIG.alwaysFill && out.length < CONFIG.minItems) {
      var fill = [];
      catalog.forEach(function (c) {
        if (targets.indexOf(c.type) === -1 || c.id === src.id || seen.has(c.id) || excludeIds.has(String(c.id))) return;
        var neutral = c.colors.indexOf(CONFIG.neutralFallback) !== -1;
        fill.push({ c: c, score: priceScore(src, c) + (neutral ? 8 : 0),
          color: neutral ? CONFIG.neutralFallback : (c.colors[0] || CONFIG.neutralFallback), filler: true });
      });
      fill.sort(function (a, b) { return b.score - a.score; });
      fill.slice(0, CONFIG.minItems - out.length).forEach(function (x) { seen.add(x.c.id); out.push(x); });
    }
    return out;
  }

  // ---------- model ----------
  var model = null, building = null;
  var modifierCalls = 0, nativeChecked = false;

  function cartKey(cart) {
    return (cart.items || []).filter(function (i) { return !i.isRewardItem; })
      .map(function (i) { return i.variantId; }).sort().join(',');
  }

  function toCard(display, pick) {
    var idx = colorOptionIndex(display);
    var variants = (display.variants || []).filter(function (v) { return v.available; });
    if (idx >= 0 && !pick.filler) {
      var same = variants.filter(function (v) { return colorWords(v['option' + (idx + 1)]).indexOf(pick.color) !== -1; });
      if (same.length) variants = same;
    }
    if (!variants.length) return null;
    var img = (variants[0].featured_image && variants[0].featured_image.src) || display.featured_image || '';
    // object handed to UpCart's own upsell module
    var native = Object.assign({}, display, {
      variants: variants.map(function (v) {
        return Object.assign({}, v, { compareAtPrice: v.compare_at_price, featuredImage: v.featured_image ? { url: v.featured_image.src } : null });
      }),
      productType: display.type,
      compareAtPrice: display.compare_at_price,
      featuredImage: display.featured_image ? { url: display.featured_image } : null,
      image: display.featured_image,
      __omnia: true
    });
    return {
      handle: display.handle, id: display.id, color: pick.color, filler: !!pick.filler,
      material: materialOf(pick.c ? pick.c.handle.replace(/-/g, ' ') : '') || null,
      name: displayName(display.title),
      url: ROOT + 'products/' + display.handle + '?variant=' + variants[0].id,
      img: img ? img.replace(/^\/\//, 'https://') + (img.indexOf('?') === -1 ? '?' : '&') + 'width=300' : '',
      variants: variants.map(function (v) {
        var label = [1, 2, 3].filter(function (n) { return n !== idx + 1 && v['option' + n]; })
          .map(function (n) { return v['option' + n]; }).join(' / ');
        return { id: v.id, label: label || v.title, price: v.price, compare: v.compare_at_price };
      }),
      native: native
    };
  }

  async function cardsFor(picks) {
    return (await Promise.all(picks.map(async function (x) {
      var display = await getProduct(x.c.handle, ROOT);   // localized copy for display
      return display ? toCard(display, x) : null;
    }))).filter(Boolean);
  }

  async function modelForHandle(handle, variantId) {
    var p = await getMatchProduct(handle);
    if (!p) return null;
    var catalog = await loadCatalog();
    var src = sourceProfile(p, variantId || (p.variants[0] || {}).id);
    var picks = rank(src, catalog, new Set([String(p.id)]));
    return { key: 'preview:' + handle, src: src, picks: picks, cards: await cardsFor(picks) };
  }

  async function buildModel(cart) {
    var items = (cart.items || []).filter(function (i) { return !i.isRewardItem; });
    if (!items.length) return { key: '', src: null, cards: [], picks: [] };
    var exclude = new Set(items.map(function (i) { return String(i.productId); }));
    var catalog = await loadCatalog();

    var sources = (await Promise.all(items.map(async function (i) {
      var p = await getMatchProduct(i.handle);       // English data even on /ar
      return p ? sourceProfile(p, i.variantId) : null;
    }))).filter(Boolean);

    sources.sort(function (a, b) {
      var pa = CONFIG.sourcePriority.indexOf(a.type), pb = CONFIG.sourcePriority.indexOf(b.type);
      return (pa === -1 ? 99 : pa) - (pb === -1 ? 99 : pb) || b.price - a.price;
    });
    if (!sources.length) { log('no source resolved from cart'); return { key: cartKey(cart), src: null, cards: [], picks: [] }; }

    var picks = [], seen = new Set();
    sources.forEach(function (s) {
      rank(s, catalog, exclude).forEach(function (x) {
        if (picks.length < CONFIG.maxItems && !seen.has(x.c.id)) { seen.add(x.c.id); picks.push(x); }
      });
    });
    var cards = await cardsFor(picks);
    log('source:', sources[0].type, sources[0].colors.join(','), '→', cards.map(function (c) { return c.handle + (c.filler ? ' (filler)' : ' [' + c.color + ']'); }));
    return { key: cartKey(cart), src: sources[0], cards: cards, picks: picks };
  }

  // ---------- UpCart's own upsell module (primary) ----------
  window.upcartModifyListOfUpsells = function (upsells) {
    modifierCalls++;
    if (CONFIG.renderMode === 'block') return upsells;
    if (!model || !model.cards.length) return upsells;
    var ours = model.cards.map(function (c) { return c.native; });
    if (!CONFIG.appendNative) return ours;
    var have = {};
    ours.forEach(function (o) { have[o.handle] = 1; });
    return ours.concat((upsells || []).filter(function (u) { return u && !have[u.handle]; }));
  };

  // did UpCart actually render our products?
  function nativeRendered() {
    if (!model || !model.cards.length) return false;
    var html = searchRoots().map(function (r) {
      return r === document ? (document.body ? document.body.innerHTML : '') : r.innerHTML;
    }).join(' ');
    return model.cards.some(function (c) { return html.indexOf(c.handle) !== -1; });
  }

  // ---------- shadow DOM helpers ----------
  function searchRoots() {
    var out = [document];
    var hosts = document.querySelectorAll('#upCart,[id*="upcart" i],[class*="upcart" i]');
    for (var i = 0; i < hosts.length; i++) {
      var sr = hosts[i].shadowRoot;
      if (sr && out.indexOf(sr) === -1) out.push(sr);
    }
    return out;
  }
  function deepGetById(id) {
    var roots = searchRoots();
    for (var i = 0; i < roots.length; i++) {
      var el = roots[i].getElementById ? roots[i].getElementById(id) : roots[i].querySelector('#' + id);
      if (el) return el;
    }
    return null;
  }
  function deepQuery(sel) {
    var roots = searchRoots();
    for (var i = 0; i < roots.length; i++) { var el = roots[i].querySelector(sel); if (el) return el; }
    return null;
  }
  function realTarget(e) { var p = e.composedPath && e.composedPath(); return (p && p[0]) || e.target; }

  // ---------- fallback block ----------
  function injectStyles(mount) {
    var root = (mount.getRootNode && mount.getRootNode()) || document;
    var target = root === document ? document.head : root;
    if (root.getElementById ? root.getElementById('omnia-match-css') : root.querySelector('#omnia-match-css')) return;
    var css = [
      '.om-match{all:initial;display:block;box-sizing:border-box;width:100%;max-width:100%;overflow:hidden;',
      'font-family:inherit;font:inherit;color:#1f1d1a;margin:10px 0 2px;--om-gold:#a8864a}',
      '.om-match *{box-sizing:border-box;font-family:inherit}',
      '.om-match[dir="rtl"]{text-align:right}',
      '.om-match__head{display:flex;align-items:center;gap:10px;margin-bottom:2px}',
      '.om-match__title{font-size:14px;font-weight:600}',
      '.om-match__rule{flex:1;height:1px;background:linear-gradient(90deg,var(--om-gold),transparent)}',
      '.om-match[dir="rtl"] .om-match__rule{background:linear-gradient(270deg,var(--om-gold),transparent)}',
      '.om-match__sub{font-size:11.5px;color:#77706a;margin:0 0 8px}',
      '.om-match__row{display:flex;gap:8px;overflow-x:auto;overflow-y:hidden;overscroll-behavior-x:contain;',
      'scroll-snap-type:x proximity;padding-bottom:6px;scrollbar-width:thin}',
      '.om-match__row::-webkit-scrollbar{height:4px}.om-match__row::-webkit-scrollbar-thumb{background:#d8d2c8;border-radius:4px}',
      '.om-match--list .om-match__row{flex-direction:column;overflow-x:hidden}',
      '.om-card{flex:0 0 44%;min-width:130px;max-width:170px;scroll-snap-align:start;display:flex;flex-direction:column;',
      'border:1px solid #e6dfd3;border-radius:8px;background:#fff;overflow:hidden}',
      '.om-match--list .om-card{flex:1 1 auto;max-width:none;flex-direction:row;align-items:center;gap:10px;padding:8px}',
      '.om-card__img{display:block;aspect-ratio:1/1;background:#f6f4f1;text-decoration:none}',
      '.om-match--list .om-card__img{width:64px;flex:0 0 64px;border-radius:6px;overflow:hidden}',
      '.om-card__img img{width:100%;height:100%;object-fit:cover;display:block}',
      '.om-card__body{display:flex;flex-direction:column;gap:5px;padding:8px;flex:1;min-width:0}',
      '.om-match--list .om-card__body{padding:0}',
      '.om-card__tags{display:flex;flex-wrap:wrap;gap:4px}',
      '.om-tag{display:inline-flex;align-items:center;gap:4px;font-size:10px;line-height:1;padding:3px 6px;border-radius:999px;background:#f5f1ea;color:#5a5249}',
      '.om-dot{width:7px;height:7px;border-radius:50%;box-shadow:inset 0 0 0 1px rgba(0,0,0,.18)}',
      '.om-card__name{font-size:12px;line-height:1.3;color:inherit;text-decoration:none;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden}',
      '.om-card__price{font-size:12px;font-weight:600;white-space:nowrap}',
      '.om-card__price s{font-weight:400;color:#8c847c;margin:0 4px;font-size:10.5px}',
      '.om-save{font-size:10px;color:#8a1f2b;font-weight:600}',
      '.om-card select{width:100%;font:inherit;font-size:11.5px;padding:5px;border:1px solid #e6dfd3;border-radius:5px;background:#fff;color:inherit}',
      '.om-card button{margin-top:auto;width:100%;font:inherit;font-size:12px;font-weight:600;padding:7px 10px;border:0;border-radius:5px;background:#1f1d1a;color:#fff;cursor:pointer}',
      '.om-match--list .om-card button{width:auto;margin:0}',
      '.om-card button:disabled{opacity:.45;cursor:not-allowed}',
      '.om-card button[data-state="added"]{background:var(--om-gold)}'
    ].join('');
    var el = document.createElement('style');
    el.id = 'omnia-match-css';
    el.textContent = css;
    target.appendChild(el);
  }

  function renderHTML(m) {
    var colorName = RTL ? (COLOR_AR[m.src.primary] || '') : (COLOR_NAME[m.src.primary] || m.src.primary || '');
    var sub = t('sub').replace('{color}', esc(colorName))
      .replace('{name}', esc(m.src.name + ' ' + (TYPE_LABEL[m.src.type] || '')));
    var cards = m.cards.map(function (card) {
      var v0 = card.variants[0];
      var multi = card.variants.length > 1;
      var save = v0.compare && v0.compare > v0.price ? Math.round((1 - v0.price / v0.compare) * 100) : 0;
      var tags = (card.color ? '<span class="om-tag"><i class="om-dot" style="background:' + (SWATCH[card.color] || '#ccc') + '"></i>' +
        esc(RTL ? (COLOR_AR[card.color] || '') : cap(COLOR_NAME[card.color] || card.color)) + '</span>' : '') +
        (card.material ? '<span class="om-tag">' + esc(MATERIAL_LABEL[card.material]) + '</span>' : '');
      return '<div class="om-card" data-handle="' + esc(card.handle) + '">' +
        '<a class="om-card__img" href="' + esc(card.url) + '">' + (card.img ? '<img src="' + esc(card.img) + '" alt="' + esc(card.name) + '" loading="lazy">' : '') + '</a>' +
        '<div class="om-card__body"><div class="om-card__tags">' + tags + '</div>' +
        '<a class="om-card__name" href="' + esc(card.url) + '">' + esc(card.name) + '</a>' +
        '<div class="om-card__price">' + money(v0.price) + (save ? '<s>' + money(v0.compare) + '</s><span class="om-save">-' + save + '%</span>' : '') + '</div>' +
        (multi ? '<select aria-label="' + esc(t('chooseSize')) + '" data-om-variant><option value="">' + esc(t('chooseSize')) + '</option>' +
          card.variants.map(function (v) { return '<option value="' + v.id + '">' + esc(v.label) + '</option>'; }).join('') + '</select>' : '') +
        '<button type="button" data-om-add' + (multi ? ' disabled' : ' data-variant="' + v0.id + '"') + '>' + esc(t('add')) + '</button>' +
        '</div></div>';
    }).join('');
    return '<div class="om-match om-match--' + CONFIG.layout + '"' + (RTL ? ' dir="rtl"' : '') + ' role="region" aria-label="' + esc(t('heading')) + '">' +
      '<div class="om-match__head"><span class="om-match__title">' + esc(t('heading')) + '</span><span class="om-match__rule"></span></div>' +
      '<div class="om-match__sub">' + sub + '</div><div class="om-match__row">' + cards + '</div></div>';
  }

  function money(cents) {
    try { if (window.upcartFormatMoney) return window.upcartFormatMoney({ cents: cents }); } catch (e) {}
    return (cents / 100).toFixed(2);
  }

  function findMount() {
    var el = deepGetById(CONFIG.mountId);
    if (el) return el;
    if (!CONFIG.autoMount) return null;
    var auto = deepGetById(CONFIG.mountId + '-auto');
    if (auto && auto.isConnected) return auto;
    var roots = searchRoots();
    for (var r = 0; r < roots.length; r++) {
      var btn = Array.prototype.find.call(roots[r].querySelectorAll('button,a'), function (b) {
        return /check\s*out|الدفع|إتمام/i.test(b.textContent || '') && b.getClientRects().length;
      });
      if (!btn) continue;
      var anchor = btn.closest('footer,[class*="footer" i],[class*="Footer"]') || btn.parentElement;
      if (!anchor || !anchor.parentElement) continue;
      auto = document.createElement('div');
      auto.id = CONFIG.mountId + '-auto';
      anchor.parentElement.insertBefore(auto, anchor);
      log('auto-mounted above checkout');
      return auto;
    }
    return null;
  }

  var paintTimer = null, observed = [];
  function observeRoots() {
    searchRoots().forEach(function (root) {
      if (observed.indexOf(root) !== -1) return;
      observed.push(root);
      new MutationObserver(function () {
        if (CONFIG.renderMode === 'native' || !model || !model.cards.length) return;
        clearTimeout(paintTimer);
        paintTimer = setTimeout(paint, 150);
      }).observe(root === document ? document.documentElement : root, { childList: true, subtree: true });
    });
  }

  function paint() {
    observeRoots();
    if (CONFIG.renderMode === 'native') return;
    var mount = findMount();
    if (!mount) return;
    bindRoot(mount.getRootNode ? mount.getRootNode() : document);
    if (!model || !model.cards.length || CONFIG.renderMode === 'auto') {
      // in auto mode only draw once we know UpCart didn't show them
      if (CONFIG.renderMode === 'auto') return;
    }
    if (mount.getAttribute('data-om-key') === model.key && mount.firstChild) return;
    injectStyles(mount);
    mount.innerHTML = renderHTML(model);
    mount.setAttribute('data-om-key', model.key);
  }

  function fallbackToBlock(why) {
    if (CONFIG.renderMode === 'block') return;
    CONFIG.renderMode = 'block';
    log('UpCart did not show the matches (' + why + ') — rendering own block');
    paint();
  }

  // ---------- events ----------
  function onChange(e) {
    var sel = realTarget(e).closest && realTarget(e).closest('[data-om-variant]');
    if (!sel) return;
    var btn = sel.closest('.om-card').querySelector('[data-om-add]');
    btn.disabled = !sel.value;
    if (sel.value) btn.setAttribute('data-variant', sel.value); else btn.removeAttribute('data-variant');
  }
  async function onClick(e) {
    var tgt = realTarget(e);
    var btn = tgt.closest && tgt.closest('[data-om-add]');
    if (!btn || btn.disabled) return;
    e.preventDefault(); e.stopPropagation();
    var id = btn.getAttribute('data-variant');
    if (!id) return;
    btn.disabled = true;
    btn.textContent = CONFIG.copy.adding;
    try {
      var r = await fetch(ROOT + 'cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(id), quantity: 1, properties: { _upsell: 'complete-the-look' } }] })
      });
      if (!r.ok) throw new Error('add failed ' + r.status);
      btn.textContent = t('added');
      btn.setAttribute('data-state', 'added');
      if (window.upcartRefreshCart) window.upcartRefreshCart();
    } catch (err) { log(err); btn.textContent = CONFIG.copy.soldOut; }
  }
  var bound = [];
  function bindRoot(root) {
    if (!root || bound.indexOf(root) !== -1) return;
    bound.push(root);
    root.addEventListener('change', onChange);
    root.addEventListener('click', onClick, true);
  }
  bindRoot(document);

  // ---------- update loop ----------
  var updateTimer = null;
  function scheduleUpdate() { clearTimeout(updateTimer); updateTimer = setTimeout(update, 80); }
  async function update() {
    var cart = window.upcartGetCart && window.upcartGetCart();
    if (!cart || !cart.items) return;
    var key = cartKey(cart);
    if (model && model.key === key) { verify(); return paint(); }
    if (building === key) return;
    building = key;
    try {
      var m = await buildModel(cart);
      if (building === key) {
        model = m;
        if (window.upcartRefreshCart && CONFIG.renderMode !== 'block') window.upcartRefreshCart();
        paint();
        verify();
      }
    } finally { if (building === key) building = null; }
  }
  function verify() {
    if (CONFIG.renderMode !== 'auto' || nativeChecked || !model || !model.cards.length) return;
    setTimeout(function () {
      if (CONFIG.renderMode !== 'auto') return;
      nativeChecked = true;
      if (nativeRendered()) log('UpCart is rendering the matches in its own upsell module');
      else fallbackToBlock(modifierCalls ? 'module returned but products not in DOM' : 'upsell module never called');
    }, 1500);
  }

  // ---------- QA ----------
  function pickRows(picks) {
    return picks.map(function (x) {
      return { handle: x.c.handle.slice(0, 44), type: x.c.type, colors: x.c.colors.join('/'),
        price: Math.round(x.c.price / 100), matched: x.color, filler: !!x.filler, score: Math.round(x.score) };
    });
  }
  window.__omniaMatch = {
    config: CONFIG,
    check: async function () {
      var rows = [];
      function row(c, ok, d) { rows.push({ check: c, status: ok ? 'PASS' : 'FAIL', detail: d || '' }); }
      row('script', true, 'v5 | locale ' + ROOT + ' | matching from ' + BASE + (RTL ? ' | RTL' : ''));
      row('UpCart API', !!(window.upcartGetCart && window.upcartSubscribeCartUpdated));
      var catalog = await loadCatalog();
      var counts = {};
      catalog.forEach(function (c) { counts[c.type] = (counts[c.type] || 0) + 1; });
      row('catalog', catalog.length > 0, catalog.length + ' ' + JSON.stringify(counts));
      var cart = window.upcartGetCart && window.upcartGetCart();
      var items = cart && cart.items ? cart.items.filter(function (i) { return !i.isRewardItem; }) : [];
      row('cart', !!cart, items.length + ' items');
      if (items.length) {
        await update();
        row('matches', !!(model && model.cards.length), model && model.src ? model.src.type + ' / ' + model.src.colors.join(',') + ' → ' + model.cards.length : 'no source resolved');
      }
      row('upsell module called', modifierCalls > 0, modifierCalls + ' calls' + (modifierCalls ? '' : ' — enable Upsells in UpCart'));
      row('rendered by UpCart', nativeRendered(), 'render mode: ' + CONFIG.renderMode);
      if (CONFIG.renderMode === 'block') {
        var mount = findMount();
        row('fallback mount', !!mount, mount ? (mount.getRootNode() !== document ? 'shadow root' : 'document') : 'none');
        row('fallback block on screen', !!deepQuery('.om-match'));
      }
      console.table(rows);
      if (model && model.cards.length) console.table(model.cards.map(function (c) {
        return { product: c.name, color: c.color, filler: c.filler, price: Math.round(c.variants[0].price / 100), variants: c.variants.length, handle: c.handle.slice(0, 38) };
      }));
      return rows;
    },
    preview: async function (handle) {
      handle = handle || (location.pathname.match(/\/products\/([^\/?#]+)/) || [])[1];
      if (!handle) return console.warn('pass a handle');
      var m = await modelForHandle(decodeURIComponent(handle));
      if (!m) return console.warn('not found');
      console.log('SOURCE', m.src);
      console.table(pickRows(m.picks));
      model = m;
      if (window.upcartOpenCart) window.upcartOpenCart();
      if (window.upcartRefreshCart) setTimeout(window.upcartRefreshCart, 200);
      setTimeout(paint, 400);
      return m.cards.map(function (c) { return c.handle; });
    },
    audit: async function (type) {
      type = type || 'full set';
      var catalog = await loadCatalog();
      var rows = catalog.filter(function (c) { return c.type === type; }).map(function (c) {
        var src = { id: c.id, type: c.type, colors: c.colors, primary: c.colors[0], material: c.material, price: c.price };
        var picks = rank(src, catalog, new Set([String(c.id)]));
        return { handle: c.handle.slice(0, 42), color: c.colors[0], shown: picks.length,
          sameColor: picks.filter(function (x) { return x.color === src.primary && !x.filler; }).length };
      });
      console.table(rows);
      var gaps = rows.filter(function (r) { return !r.sameColor; });
      console.log(gaps.length + '/' + rows.length + ' without a same-color partner: ' + uniq(gaps.map(function (g) { return g.color; })).join(', '));
      return rows;
    },
    mode: function (m) { CONFIG.renderMode = m; nativeChecked = false; if (window.upcartRefreshCart) window.upcartRefreshCart(); paint(); return m; },
    parse: function (title) { return { name: nameSegment(title), type: typeOf(nameSegment(title)) || typeOf(title), colors: colorWords(nameSegment(title)), material: materialOf(title) }; },
    test: async function (h) { var m = await modelForHandle(h); if (!m) return console.warn('not found'); console.log('SOURCE', m.src); console.table(pickRows(m.picks)); return m.picks; },
    model: function () { return model; },
    roots: searchRoots,
    reset: function () { model = null; catalogPromise = null; nativeChecked = false; try { sessionStorage.removeItem(CATALOG_KEY); } catch (e) {} scheduleUpdate(); }
  };

  // ---------- boot ----------
  var idle = window.requestIdleCallback ? window.requestIdleCallback.bind(window) : window.setTimeout.bind(window);
  try {
    var tries = 0;
    (function hook() {
      if (window.upcartSubscribeCartUpdated) {
        window.upcartSubscribeCartUpdated(scheduleUpdate);
        if (window.upcartSubscribeCartLoaded) window.upcartSubscribeCartLoaded(scheduleUpdate);
        if (window.upcartSubscribeCartOpened) window.upcartSubscribeCartOpened(function () { scheduleUpdate(); setTimeout(paint, 250); });
        if (window.upcartSubscribeAddedToCart) window.upcartSubscribeAddedToCart(scheduleUpdate);
        scheduleUpdate();
        log('subscribed to UpCart events');
        return;
      }
      if (++tries < 60) setTimeout(hook, 500);
      else console.warn('[omnia-match] UpCart events never appeared');
    })();
    observeRoots();
    setInterval(observeRoots, 2000);
    idle(function () {
      loadCatalog().then(function (c) { log('ready — catalog:', c.length, '| run __omniaMatch.check()'); });
      var m = location.pathname.match(/\/products\/([^\/?#]+)/);
      if (m) getMatchProduct(decodeURIComponent(m[1]));
    });
  } catch (e) { console.error('[omnia-match] boot error', e); }
  log('booted');
})();